import { UUID } from "@bitory-gmbh/nidavellir";
import { HTMLAttributes } from "react";
import { useCustomersCustomerAddressShowQuery } from "@/services/backend/customers/api/customer-api";
import { cn } from "@/shared/lib/utils";
import { Skeleton } from "@/shared/components/ui/skeleton";

export function CustomerAddressLine({
  customerId,
  className,
  hideCity = false,
}: { customerId: UUID; hideCity?: boolean } & HTMLAttributes<HTMLSpanElement>) {
  const { data, isError, isLoading } = useCustomersCustomerAddressShowQuery({
    customerId,
  });

  if (isError) {
    return "";
  }

  if (isLoading) {
    return <Skeleton className="h-4 w-48" />;
  }

  return (
    <span className={cn(className)}>
      {`${data!.address.street}, ${data!.address.postalCode}`}
      {!hideCity && ` ${data!.address.city}`}
    </span>
  );
}
